<template>
  <pl-modal :visible="showInventoryDialog" @close="closeDialog" max-width="600px">
    <div slot="header">Инкассация</div>
    <v-form ref="savePackageForm" slot="content">
      <div key="textfield">
        <v-text-field :value="savePackageNumber" label="Номер сейф-пакета" :rules="[rules.required]" disabled>
        </v-text-field>
      </div>
      <div>
        <v-text-field v-model="savePackageSum" label="Сумма" :rules="[rules.required]" type="number"></v-text-field>
      </div>
    </v-form>
    <v-layout slot="footer" align-center justify-end row fill-height>
      <v-btn class="pl-btn pl-btn_default" @click="closeDialog">
        <v-icon class="mr-1">clear</v-icon>
        Закрыть
      </v-btn>

      <!--            v-if="user.unit.settings.sendSavePackagesWithoutClose"-->
      <v-btn class="pl-btn pl-btn_primary" :loading="collectionLoading" @click="createCollection">
        <v-icon class="mr-1">collections_bookmark</v-icon>
        Провести инкассацию
      </v-btn>
    </v-layout>
  </pl-modal>
</template>

<script>
import PLModal from '@/components/Modal/PLModal'
import form_rules from '@/mixins/form_rules'
import fullName from '@/helpers/full_name'
import store from '@/store/index'
import { mapGetters } from 'vuex'

export default {
  name: 'AddInventory',
  props: {
    opened: {
      required: true,
    },
    curentUser: {
      required: true,
    },
  },
  data: () => ({
    collectionLoading: false,
    showInventoryDialog: false,
    savePackageSum: null,
    savePackageNumber: null,
  }),
  mixins: [form_rules],
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    clearData() {
      this.savePackageSum = null
      this.savePackageNumber = null
      this.showInventoryDialog = false
      this.$emit('closeInventoryDialog')
    },
    closeDialog() {
      this.clearData()
      this.showInventoryDialog = false
    },
    async createCollection() {
      this.collectionLoading = true

      try {
        await this.$axios.post(`${this.$config.server}/${this.$config.modules.crm.api.KKM.safePackage}`, {
          sum: this.savePackageSum,
          code: this.savePackageNumber,
        })
        this.closeDialog()
        this.$notify({
          group: 'hasBottomNavigation',
          title: 'Инкассация проведена',
          type: 'success',
        })
      } catch (e) {
        this.$notify({
          group: 'hasBottomNavigation',
          title: 'Произошла ошибка',
          type: 'error',
        })
      } finally {
        this.collectionLoading = false
      }
    },
    onBarcodeScanned(barcode) {
      this.savePackageNumber = barcode
    },
    init() {
      this.$barcodeScanner.init(this.onBarcodeScanned)
    },
    disable() {
      this.$barcodeScanner.destroy()
    },
  },
  watch: {
    opened(val) {
      if (val) {
        this.showInventoryDialog = true
      }
    },
    showInventoryDialog(val) {
      if (val) {
        this.init()
      } else {
        this.disable()
      }
    },
  },
}
</script>

<style scoped></style>
